import { HeroId } from "../../../../shared/src/index.ts";
import type { VoiceScript } from "../voice-types.ts";

const script = {
  hero: HeroId.Bulk,
  voices: {
    banter: {
      description:
        "nervy mild scientist tenor, quick apologetic academic diction, anxious but kind, small dry lab microphone texture",
      seed: 10110,
      guidance: 0.72,
      loudness: 0.72,
    },
    bulk: {
      description:
        "huge gravelly monster bass, explosive breath, strained readable rage, thick chest distortion and doubled low octave, wholly original creature-hero tone",
      seed: 10109,
      guidance: 0.82,
      loudness: 0.9,
      fx: { pitch: -2, doubler: true, octaver: true, distortion: 0.18 },
    },
  },
  lines: {
    select: [
      {
        id: "select_1_banter",
        text: "Science solves problems.",
        voice: "banter",
        form: 0,
      },
      {
        id: "select_2_banter",
        text: "You're going to need Banner.",
        voice: "banter",
        form: 0,
      },
      {
        id: "select_3_banter",
        text: "I am Bruce Banner, and I am calm.",
        voice: "banter",
        form: 0,
      },
      {
        id: "select_4_banter",
        text: "Banner can make a difference.",
        voice: "banter",
        form: 0,
      },
    ],
    spawn: [
      {
        id: "spawn_1_banter",
        text: "Let's hope the Bulk is feeling inspired…",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_2_banter",
        text: "Who needs an army, Captain? You've got a Bulk!",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_3_banter",
        text: "I can feel my rage boiling over…",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_4_banter",
        text: "I hope you and the Bulk can play nice, Logan…",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_5_banter",
        text: "I want to understand the Timestream Entanglement.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_6_banter",
        text: "I'm warming up to the field missions. They're breaks from the labs.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_7_banter",
        text: "Doom is brilliant. So am I. We can out-think him.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_8_banter",
        text: "We will build the TRD, and we will set this universe right.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_9_banter",
        text: "It's not easy being Banner when everyone wants you-know-who.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_10_banter",
        text: "Bulk and I, we're a team.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_11_banter",
        text: "Being the Bulk isn't so bad.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_12_banter",
        text: "I'm trying to make the gamma in me useful!",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_13_banter",
        text: "I'm not Bulk. He's part of me, but he's not all of me.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_14_banter",
        text: "Bulk isn't the only one with a temper. Banner can smash things too. Like instruments that don't work.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_15_banter",
        text: "I can store gamma energy…but anger I have to let go.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_16_banter",
        text: "Banner is tactical support, Bulk is all heavy duty.",
        voice: "banter",
        form: 0,
      },
      {
        id: "spawn_17_bulk",
        text: "Listen, Bulk admit he still working on his anger management.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "spawn_18_bulk",
        text: "Took me years to control this form.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "spawn_19_bulk",
        text: "Can't let the Monster out at the wrong time.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "spawn_20_bulk",
        text: "Not used to being a hero.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "spawn_21_bulk",
        text: "Bulk is a bigger hero than Banner!",
        voice: "bulk",
        form: 1,
      },
      {
        id: "spawn_22_bulk",
        text: "Smartest thing Banner ever did was make Gamma Belt stretchy.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "spawn_23_bulk",
        text: "Never say Bulk is stupid just because Banner is smart.",
        voice: "bulk",
        form: 1,
      },
    ],
    respawn: [
      {
        id: "respawn_1_banter",
        text: "Let's try this again.",
        voice: "banter",
        form: 0,
      },
      {
        id: "respawn_2_banter",
        text: "If at first you don't succeed…",
        voice: "banter",
        form: 0,
      },
      {
        id: "respawn_3_banter",
        text: "Did I come through the Green Door again?",
        voice: "banter",
        form: 0,
      },
      {
        id: "respawn_4_banter",
        text: "I have to get this right this time.",
        voice: "banter",
        form: 0,
      },
      {
        id: "respawn_5_banter",
        text: "Here we go again.",
        voice: "banter",
        form: 0,
      },
      {
        id: "respawn_6_banter",
        text: "Banner's back!",
        voice: "banter",
        form: 0,
      },
      {
        id: "respawn_7_banter",
        text: "You were expecting the Bulk?",
        voice: "banter",
        form: 0,
      },
    ],
    ult_ally: [
      {
        id: "ult_ally_1_banter",
        text: "My turn now!",
        voice: "banter",
        form: 0,
      },
      {
        id: "ult_ally_2_bulk",
        text: "NOW BULK MAAAAD!",
        voice: "bulk",
        form: 1,
      },
    ],
    ult_enemy: [
      {
        id: "ult_enemy_1_banter",
        text: "I'm Bulking out!",
        voice: "banter",
        form: 0,
      },
      { id: "ult_enemy_2_bulk", text: "BULK SMASH!", voice: "bulk", form: 1 },
    ],
    ability2: [
      {
        id: "ability2_1_banter",
        text: "Stay right there.",
        voice: "banter",
        form: 0,
      },
      {
        id: "ability2_2_banter",
        text: "Heavy, huh?",
        voice: "banter",
        form: 0,
      },
      {
        id: "ability2_3_banter",
        text: "Stick around!",
        voice: "banter",
        form: 0,
      },
      { id: "ability2_4_bulk", text: "Stay!", voice: "bulk", form: 1 },
      { id: "ability2_5_bulk", text: "Gamma prison!", voice: "bulk", form: 1 },
      { id: "ability2_6_bulk", text: "Stop!", voice: "bulk", form: 1 },
      { id: "ability2_7_bulk", text: "Escape this!", voice: "bulk", form: 1 },
      { id: "ability2_8_bulk", text: "No tricks!", voice: "bulk", form: 1 },
      { id: "ability2_9_bulk", text: "Too slow!", voice: "bulk", form: 1 },
    ],
    ability1: [
      { id: "ability1_1_bulk", text: "Bulk protect!", voice: "bulk", form: 1 },
      {
        id: "ability1_2_bulk",
        text: "No smashing us now!",
        voice: "bulk",
        form: 1,
      },
      { id: "ability1_3_bulk", text: "Gamma Shield!", voice: "bulk", form: 1 },
    ],
    kill: [
      {
        id: "kill_1_banter",
        text: "I haven't even started.",
        voice: "banter",
        form: 0,
      },
      {
        id: "kill_2_banter",
        text: "Don't underestimate me!",
        voice: "banter",
        form: 0,
      },
      { id: "kill_3_banter", text: "Gamma blast!", voice: "banter", form: 0 },
      { id: "kill_4_banter", text: "Nerd win!", voice: "banter", form: 0 },
      {
        id: "kill_5_banter",
        text: "Now do you believe I can fight?",
        voice: "banter",
        form: 0,
      },
      {
        id: "kill_6_banter",
        text: "I'm heroic in my own way.",
        voice: "banter",
        form: 0,
      },
      {
        id: "kill_7_bulk",
        text: "Fight Bulk, you lose.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "kill_8_bulk",
        text: "Everyone wants to take on Bulk. Idiots.",
        voice: "bulk",
        form: 1,
      },
      { id: "kill_9_bulk", text: "You're smashed.", voice: "bulk", form: 1 },
      {
        id: "kill_10_bulk",
        text: "Was that too hard? Heh.",
        voice: "bulk",
        form: 1,
      },
      { id: "kill_11_bulk", text: "Bulk is hero!", voice: "bulk", form: 1 },
      { id: "kill_12_bulk", text: "Green rage!", voice: "bulk", form: 1 },
      { id: "kill_13_bulk", text: "Too puny.", voice: "bulk", form: 1 },
      { id: "kill_14_bulk", text: "Punchout.", voice: "bulk", form: 1 },
      { id: "kill_15_bulk", text: "Down and out.", voice: "bulk", form: 1 },
      { id: "kill_16_bulk", text: "Stomped 'em.", voice: "bulk", form: 1 },
    ],
    multikill: [
      {
        id: "multikill_1_banter",
        text: "Un deux trois!",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_2_banter",
        text: "Three! I'm not a liability!",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_3_banter",
        text: "Yes! Three straight!",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_4_banter",
        text: "Five!? I love fighting.",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_5_banter",
        text: "That makes five. Wow.",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_6_banter",
        text: "Who needs the Bulk anyway?",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_7_banter",
        text: "Wow. How did that happen?",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_8_banter",
        text: "Puny Banner got 'em all!",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_9_banter",
        text: "And I never even Bulked up!",
        voice: "banter",
        form: 0,
      },
      {
        id: "multikill_10_bulk",
        text: "Want three more.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "multikill_11_bulk",
        text: "Three? Just getting started.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "multikill_12_bulk",
        text: "Three! How many you got?",
        voice: "bulk",
        form: 1,
      },
      {
        id: "multikill_13_bulk",
        text: "Bulk on a roll!",
        voice: "bulk",
        form: 1,
      },
      {
        id: "multikill_14_bulk",
        text: "Five five five five five!",
        voice: "bulk",
        form: 1,
      },
      { id: "multikill_15_bulk", text: "Yeah, five.", voice: "bulk", form: 1 },
      {
        id: "multikill_16_bulk",
        text: "Puny friends. Keep up.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "multikill_17_bulk",
        text: "Ha ha ha, Bulk smashed all enemies!",
        voice: "bulk",
        form: 1,
      },
      {
        id: "multikill_18_bulk",
        text: "Hmm, Bulk might as well fight solo!",
        voice: "bulk",
        form: 1,
      },
    ],
    low_hp: [
      {
        id: "low_hp_1_banter",
        text: "Whew. Yeah. Heal me.",
        voice: "banter",
        form: 0,
      },
      {
        id: "low_hp_2_banter",
        text: "Oh, I needed that.",
        voice: "banter",
        form: 0,
      },
      {
        id: "low_hp_3_bulk",
        text: "Ah, was just a scratch.",
        voice: "bulk",
        form: 1,
      },
      { id: "low_hp_4_bulk", text: "Good.", voice: "bulk", form: 1 },
    ],
    healed: [
      {
        id: "healed_1_banter",
        text: "Thanks. Wish I could heal you back.",
        voice: "banter",
        form: 0,
      },
      {
        id: "healed_2_banter",
        text: "I'll take all the healing I can get.",
        voice: "banter",
        form: 0,
      },
      {
        id: "healed_3_banter",
        text: "That felt good.",
        voice: "banter",
        form: 0,
      },
      { id: "healed_4_banter", text: "Refreshing!", voice: "banter", form: 0 },
      {
        id: "healed_5_bulk",
        text: "Ah, strong again!",
        voice: "bulk",
        form: 1,
      },
      { id: "healed_6_bulk", text: "Bulk grateful.", voice: "bulk", form: 1 },
      {
        id: "healed_7_bulk",
        text: "Love it, feels so good.",
        voice: "bulk",
        form: 1,
      },
      {
        id: "healed_8_bulk",
        text: "Good. Stronger again.",
        voice: "bulk",
        form: 1,
      },
    ],
  },
} satisfies VoiceScript;

export default script;
